const GuineaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111560)">
      <path
        d="M26.957 1.24406C24.7903 0.440078 22.4467 0 20.0003 0C17.5539 0 15.2105 0.440078 13.0439 1.24391L12.1743 20L13.0438 38.7561C15.2105 39.56 17.5539 40 20.0003 40C22.4468 40 24.7903 39.56 26.957 38.7559L27.8265 20L26.957 1.24406Z"
        fill="#FFDA44"
      />
      <path
        d="M0 20.0012C0 28.6004 5.4275 35.9314 13.0435 38.7571V1.24512C5.4275 4.07105 0 11.4018 0 20.0012Z"
        fill="#D80027"
      />
      <path
        d="M40.0001 20.0012C40.0001 11.4018 34.5726 4.07105 26.9565 1.24512V38.7572C34.5726 35.9314 40.0001 28.6004 40.0001 20.0012Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111560">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GuineaSvg;
